var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex flex-col min-h-screen"},[_c('navigation-bar'),_vm._v(" "),_c('nuxt',{staticClass:"flex-grow"}),_vm._v(" "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }